/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const marketplace_group_ticket_listed_warning = () => `Terwijl dit groeps ticket te koop staat, zijn de individuele tickets hieronder niet geldig voor toegang of gebruik. Ze worden weer actief als de aanbieding wordt geannuleerd of voor de nieuwe eigenaar als verkocht.`
